export default __webpack_public_path__ + "static/media/icn-trash-bin.87f9dfaa.svg";